__turbopack_context__.v({
  "card": "HeroCards-module__V82Wiq__card",
  "cardLayer": "HeroCards-module__V82Wiq__cardLayer",
  "fadeIn": "HeroCards-module__V82Wiq__fadeIn",
});
